export default __webpack_public_path__ + "static/media/title_th_sp.c154bb45.png";